import { ProcessImageType } from '@ai-color-modules/gen_proto/ai_color_simulation/v1/messages_pb'
import type { SimulatedColorSimulationImages } from '@ai-color-modules/gen_proto/api_proto/v1/ai_color_simulation_pb'

/**
 * ユーザーに表示する画像タイプのホワイトリスト
 * - UNSPECIFIED: 現況画像（CreateOriginal で type=0 として保存される）
 * - PROCESSED: 結果画像（色変換済み）
 *
 * マスク系（MASKED_WALL/ROOF/GUTTER/FASCIA など）や CLEANED（廃止）は表示しない。
 * 新しいマスクタイプを proto に追加した際にも、本ホワイトリストを更新しない限り
 * 自動的に非表示扱いとなる（マスクが追加される頻度の方が高いため）。
 */
const VISIBLE_IMAGE_TYPES: readonly ProcessImageType[] = [
  ProcessImageType.UNSPECIFIED,
  ProcessImageType.PROCESSED,
] as const

/**
 * 画像タイプがユーザーに表示すべきものかを判定
 */
export const isVisibleImageType = (type: ProcessImageType): boolean => {
  return VISIBLE_IMAGE_TYPES.includes(type)
}

/**
 * 表示可能な画像のみをフィルタリング
 */
export const filterVisibleSimulatedImages = (
  images: SimulatedColorSimulationImages[] | undefined,
): SimulatedColorSimulationImages[] => {
  return (images ?? []).filter(img => isVisibleImageType(img.type))
}
